export default "__VITE_ASSET__B74hafmP__"